/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * CartService APIs
 */

import addGreetingCard from './addGreetingCard';
import addPassportToCart from './addPassportToCart';
import addProductPersonalization from './addProductPersonalization';
import addToCart from './addToCart';
import addUpsell from './addUpsell';
import applyPromotion from './applyPromotion';
import applyTalonRewards from './applyTalonRewards';
import availablityDeliveryCalendar from './availablityDeliveryCalendar';
import calculateCart from './calculateCart';
import calculateDynamicPassport from './calculateDynamicPassport';
import cartCount from './cartCount';
import deleteCart from './deleteCart';
import deleteCartItem from './deleteCartItem';
import deleteViewTime from './deleteViewTime';
import donation from './donation';
import duplicateCartItem from './duplicateCartItem';
import displayCalendar from './displayCalendar';
import displayViewTime from './displayViewTime';
import editRecipient from './editRecipient';
import expressCheckout from './expressCheckout';
import findOrderDetailsByUser from './findOrderDetailsByUser';
import findOrderDetailsByMember from './findOrderDetailsByMember';
import findOrderStatusByUser from './findOrderStatusByUser';
import generateGreetingCard from './generateGreetingCard';
import getApplePayMerchantId from './getApplePayMerchantId';
import getCartCount from './getCartCount';
import getCartOrderDetails from './getCartOrderDetails';
import getCartNoId from './getCartNoId';
import getChatgptMessage from './getChatgptMessage';
import getDeliveryTime from './getDeliveryTime';
import getLabelGreetingCard from './getLabelGreetingCard';
import getPayment from './getPayment';
import getPaymentCommonClientToken from './getPaymentCommonClientToken';
import getRewardBalance from './getRewardBalance';
import getRewardElegilibity from './getRewardElegilibity';
import getKlarnaClientToken from './getKlarnaClientToken';
import giftCard from './giftCard';
import initPayment from './initPayment';
import mergeCart from './mergeCart';
import paymentClientToken from './paymentClientToken';
import paypalClientToken from './paypalClientToken';
import paypalPaymentToken from './paypalPaymentToken';
import placeOrderCart from './placeOrderCart';
import prepareCart from './prepareCart';
import processVisaCheckoutData from './processVisaCheckoutData';
import recordAttributions from './recordAttributions';
import removeGiftCard from './removeGiftCard';
import removeOrderItem from './removeOrderItem';
import removePromotion from './removePromotion';
import removeTalonRewards from './removeTalonRewards';
import saveRecipient from './saveRecipient';
import saveGreetingMessage from './saveGreetingMessage';
import saveRecipientNoCartId from './saveRecipientNoCartId';
import sendGreetingCardToCardIsle from './sendGreetingCardToCardIsle';
import setBillingAddress from './setBillingAddress';
import shippingMethods from './getShippingMethods';
import updateAttribute from './updateAttribute';
import updateCartItemDeliveryInfo from './updateCartItemDeliveryInfo';
import updateCartItemQuantity from './updateCartItemQuantity';
import updateDeliveryTime from './updateDeliveryTime';
import updateFuneralViewTime from './updateFuneralViewTime';
import updatePersonalization from './updatePersonalizationLines';
import validateCart from './validateCart';

const cartServiceClient = {
    addGreetingCard,
    addPassportToCart,
    addProductPersonalization,
    addToCart,
    addUpsell,
    applyPromotion,
    applyTalonRewards,
    availablityDeliveryCalendar,
    calculateCart,
    calculateDynamicPassport,
    cartCount,
    deleteCart,
    deleteCartItem,
    deleteViewTime,
    displayCalendar,
    displayViewTime,
    donation,
    duplicateCartItem,
    editRecipient,
    expressCheckout,
    findOrderDetailsByUser,
    findOrderDetailsByMember,
    findOrderStatusByUser,
    getApplePayMerchantId,
    getCartCount,
    getCartNoId,
    getCartOrderDetails,
    getChatgptMessage,
    getDeliveryTime,
    getLabelGreetingCard,
    generateGreetingCard,
    getPaymentCommonClientToken,
    getKlarnaClientToken,
    getPayment,
    getRewardBalance,
    getRewardElegilibity,
    giftCard,
    initPayment,
    mergeCart,
    paymentClientToken,
    paypalClientToken,
    paypalPaymentToken,
    placeOrderCart,
    prepareCart,
    processVisaCheckoutData,
    recordAttributions,
    removeGiftCard,
    removeOrderItem,
    removePromotion,
    removeTalonRewards,
    saveGreetingMessage,
    saveRecipient,
    saveRecipientNoCartId,
    sendGreetingCardToCardIsle,
    setBillingAddress,
    shippingMethods,
    updateAttribute,
    updateCartItemDeliveryInfo,
    updateCartItemQuantity,
    updateDeliveryTime,
    updateFuneralViewTime,
    updatePersonalization,
    validateCart,
};

export default cartServiceClient;
